import React from 'react';

/* Clean vector sheep silhouette — replaces the 🐑 emoji */
export default function SheepIcon({ size = 40, color = '#7A1010', opacity = 1 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* Body wool */}
      <ellipse cx="32" cy="32" rx="20" ry="16" fill={color} opacity={opacity * 0.15} />
      <circle cx="20" cy="28" r="11" fill={color} opacity={opacity * 0.9} />
      <circle cx="32" cy="24" r="12" fill={color} opacity={opacity * 0.9} />
      <circle cx="44" cy="28" r="11" fill={color} opacity={opacity * 0.9} />
      <circle cx="26" cy="34" r="10" fill={color} opacity={opacity * 0.9} />
      <circle cx="38" cy="34" r="10" fill={color} opacity={opacity * 0.9} />
      {/* Head */}
      <ellipse cx="32" cy="19" rx="7" ry="6" fill={color} opacity={opacity} />
      {/* Eyes */}
      <circle cx="29.5" cy="18" r="1.2" fill="white" />
      <circle cx="34.5" cy="18" r="1.2" fill="white" />
      <circle cx="29.7" cy="18.2" r="0.55" fill={color} opacity={opacity} />
      <circle cx="34.7" cy="18.2" r="0.55" fill={color} opacity={opacity} />
      {/* Ears */}
      <ellipse cx="24" cy="20" rx="3.5" ry="2" fill={color} opacity={opacity * 0.8} transform="rotate(-20 24 20)" />
      <ellipse cx="40" cy="20" rx="3.5" ry="2" fill={color} opacity={opacity * 0.8} transform="rotate(20 40 20)" />
      {/* Legs */}
      <rect x="23" y="42" width="4" height="12" rx="2" fill={color} opacity={opacity * 0.8} />
      <rect x="29" y="43" width="4" height="11" rx="2" fill={color} opacity={opacity * 0.8} />
      <rect x="35" y="43" width="4" height="11" rx="2" fill={color} opacity={opacity * 0.8} />
      <rect x="41" y="42" width="4" height="12" rx="2" fill={color} opacity={opacity * 0.8} />
    </svg>
  );
}
